<style lang="scss" scoped>
@import "./new-client.modal";

.main-container {
    display: flex;
    flex-direction: column;
    margin: 2em;
}

.inputs-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 2vw;
}

.inputs-wrapper > div {
    flex: 1;
}

.input-title {
    font-weight: 400;
    font-size: 1.6em;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #898989;
}

.input-container {
    width: 45vw;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 12px;
    margin-top: 5px;
    display: flex;
}

.input-value {
    border: none;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.15px;
    color: #b3b3b3;
}

.input-value:focus {
    border: none;
    outline: none;
}

.selects-wrapper {
    width: 45vw;
}

.activity-selects-wrapper {
    width: 30vw;
}

.form-check-input {
    accent-color: #cc6119;
}
.form-check-input-disabled {
    accent-color: gray;
}
.client-select-container {
    width: 45vw;
    margin-bottom: 2vh;
}
.client-select-container2 {
    width: 30vw;
    margin-bottom: 2vh;
}
.client-field-sectors-container {
    display: flex;
    gap: 2vw;
    margin-bottom: 2vh;
}
.client-field-sector {
    font-weight: 400;
    font-size: 1.6em;
    color: #898989;
    border-bottom: 1px solid #ff7110;
}

.error {
    color: #ff4444;
    font-size: 0.875em;
    margin-top: 6px;
    display: block;
    font-weight: 500;
    padding: 4px 8px;
    background-color: #fff5f5;
    border-left: 3px solid #ff4444;
    border-radius: 4px;
}

.input-group {
    margin-bottom: 2vh;
}

.section-title {
    font-size: 1.8em;
    font-weight: 600;
    color: var(--primary-color);
    margin: 1em 0 1em 0;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 0.5em;
}

@media only screen and (max-width: 700px) {
    .client-select-container {
        width: 100%;
    }
    .client-select-container2 {
        width: 100%;
    }
    .inputs-wrapper {
        flex-direction: column;
    }

    .input-container {
        width: 100%;
    }

    .activity-selects-wrapper {
        width: 100%;
    }

    .selects-wrapper {
        width: 100%;
    }
}
</style>
<template>
    <div class="main-container">
        <!-- Informações Básicas -->
        <div class="section-title">Informações Básicas</div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div>
                    <div class="input-title" title="Obrigatório">
                        CNPJ
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required|cnpj" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="client-cnpj"
                                v-mask="'## ### ###/####-##'"
                                v-model="client.cnpj"
                                class="input-value"
                                placeholder="Digite o CNPJ"
                                v-on:keyup.enter="cnpjEnter()"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <div class="input-title" title="Obrigatório">
                        Nome do Grupo
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="group-name"
                                v-model="client.group_name"
                                class="input-value"
                                placeholder="Digite o nome do grupo"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div>
                    <div class="input-title" title="Obrigatório">
                        Razão Social
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input type="text" v-model="client.name" class="input-value" placeholder="Digite a razão social" />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <div class="input-title" title="Obrigatório">
                        Nome Fantasia
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="client-trading-name"
                                v-model="client.trading_name"
                                class="input-value"
                                placeholder="Digite o nome fantasia"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <!-- Informações de Contato -->
        <div class="section-title">Informações de Contato</div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div>
                    <div class="input-title" title="Obrigatório">
                        Email
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input type="text" id="client-email" v-model="client.email" class="input-value" placeholder="Digite o email" />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <div class="input-title" title="Obrigatório">
                        Telefone
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="client-phone"
                                v-mask="'(##) #.####-####'"
                                v-model="client.phone"
                                class="input-value"
                                placeholder="Digite o telefone"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div>
                    <div class="input-title" title="Obrigatório">
                        Contato
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="client-contact"
                                v-model="client.contact"
                                class="input-value"
                                placeholder="Digite o contato"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <div class="input-title" title="Obrigatório">
                        Site
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                id="client-website"
                                v-model="client.site_url"
                                class="input-value"
                                placeholder="Digite o site"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <!-- Configurações Operacionais -->
        <div class="section-title">Configurações Operacionais</div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <ValidationProvider name="resale" rules="required" v-slot="v" :value="client.resale">
                    <SelectCheckFiltered
                        title="Tipo Revenda"
                        :placeholder="client.resale ? client.resale.name : 'Selecione a revenda'"
                        :list="resales"
                        class="client-select-container"
                        :alert="true"
                        :selected="client.resale"
                        :action="
                            (value) => {
                                client.resale = value;
                                v.validate(value);
                            }
                        "
                    />
                    <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider name="sector" rules="required" v-slot="v" :value="client.sectors[0]">
                    <SelectCheckFiltered
                        title="Ramo de Atividade"
                        :placeholder="client.sectors.length > 0 ? client.sectors[0].name : 'Selecione o ramo'"
                        :list="sectors"
                        class="client-select-container"
                        :alert="true"
                        :selected="client.sectors.length > 0 ? client.sectors[0] : null"
                        :action="
                            (value) => {
                                client.sectors = [value];
                                v.validate(value);
                            }
                        "
                    />
                    <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div class="selects-wrapper">
                    <div class="input-title" style="margin-bottom: 5px" title="Obrigatório">
                        Tipo Entrega
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="radio-group">
                            <div class="form-check">
                                <input
                                    type="radio"
                                    id="client-delivery-type-one"
                                    class="form-check-input"
                                    value="1"
                                    v-model="client.delivery_type_id"
                                />
                                <label class="form-check-label" for="client-delivery-type-one">
                                    CIF
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    id="client-delivery-type-two"
                                    class="form-check-input"
                                    value="2"
                                    v-model="client.delivery_type_id"
                                />
                                <label class="form-check-label" for="client-delivery-type-two">
                                    CIF/FOB
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    id="client-delivery-type-three"
                                    class="form-check-input"
                                    value="3"
                                    v-model="client.delivery_type_id"
                                />
                                <label class="form-check-label" for="client-delivery-type-three">
                                    FOB
                                </label>
                            </div>
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <div class="selects-wrapper">
                    <div class="input-title" style="margin-bottom: 5px" title="Obrigatório">
                        Cotação CX/UN
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="radio-group">
                            <div class="form-check">
                                <input
                                    type="radio"
                                    :disabled="isResaller"
                                    id="client-order-type-one"
                                    class="form-check-input"
                                    value="1"
                                    v-model="client.order_type"
                                />
                                <label class="form-check-label" for="client-order-type-one">
                                    Pedido Caixa
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    id="client-order-type-two"
                                    :class="{ 'form-check-input-disabled': isResaller }"
                                    class="form-check-input"
                                    value="0"
                                    v-model="client.order_type"
                                />
                                <label class="form-check-label" for="client-order-type-two">
                                    Pedido Unidade
                                </label>
                            </div>
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <div class="selects-wrapper" style="width: 45vw">
                    <div class="input-title" style="margin-bottom: 5px" title="Obrigatório">
                        Método de Fechamento
                        <span class="material-icons" style="color: #cb595b"> info </span>
                    </div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="radio-group">
                            <div class="form-check">
                                <input
                                    type="radio"
                                    id="closing-method-one"
                                    :class="{ 'form-check-input-disabled': isResaller }"
                                    class="form-check-input"
                                    value="ANALISE_POR_LOJA"
                                    v-model="client.closing_method"
                                />
                                <label class="form-check-label" for="closing-method-one">
                                    Análise por loja
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    :disabled="isResaller"
                                    id="closing-method-two"
                                    class="form-check-input"
                                    value="COM_VALOR"
                                    v-model="client.closing_method"
                                />
                                <label class="form-check-label" for="closing-method-two">
                                    Análise por Fornecedor
                                </label>
                            </div>
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>

        <!-- Configurações Adicionais -->
        <div class="section-title">Configurações Adicionais</div>

        <div class="input-group">
            <div class="inputs-wrapper">
                <SelectMultiCheckFiltered
                    v-if="!client.id"
                    title="Categorias"
                    placeholder="Selecione a categoria"
                    :list="categories"
                    :alert="true"
                    :action="(value) => (client.categories = value)"
                    :lock="isResaller"
                    class="client-select-container"
                />
                <SelectCheckFiltered
                    title="Sistema utilizado"
                    :placeholder="selectedSystem ? selectedSystem.descricao : 'Selecione o sistema'"
                    :list="systems"
                    class="client-select-container"
                    :alert="false"
                    :action="setSelectedSystem"
                    track-by="id"
                    label-by="descricao"
                    :selected="selectedSystem"
                />
            </div>
        </div>

        <div v-if="isEdit" class="input-group">
            <div class="inputs-wrapper">
                <div>
                    <div class="input-title">
                        Id BomControle
                    </div>
                    <ValidationProvider v-slot="v">
                        <div class="input-container">
                            <input
                                type="number"
                                id="client-id-bomcontrole"
                                v-model="client.id_bomcontrole"
                                class="input-value"
                                placeholder="Digite o Id"
                            />
                        </div>
                        <span v-if="v.errors[0]" class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ClientService from "@/services/v3/client.service";
import CategoryService from "@/services/v3/category.service";
import SelectCheckFiltered from "../../../components/ui/inputs/SelectCheckFiltered.vue";
import SelectMultiCheckFiltered from "../../../components/ui/inputs/SelectMultiCheckFiltered.vue";

export default {
    mixins: [loaderMixin],
    props: ["client", "getCnpjInfo", "isResaller", "resales", "atvError", "systems", "isEdit"],
    components: {
        ValidationProvider,
        ValidationObserver,
        SelectCheckFiltered,
        SelectMultiCheckFiltered,
    },
    data() {
        return {
            svc: new ClientService(),
            cat_svc: new CategoryService(),
            categories: [],
            request_types: [],
            sectors: [],
        };
    },
    computed: {
        selectedSystem() {
            if (!this.client.id_sistema || !this.systems.length) return null;
            const system = this.systems.find((s) => s.id == this.client.id_sistema);
            return system;
        },
    },
    methods: {
        cnpjEnter() {
            let cnpj = this.client.cnpj.replace("/", "");
            cnpj = cnpj.replace("-", "");
            cnpj = cnpj.replace(" ", "");
            cnpj = cnpj.replace(" ", "");
            this.getCnpjInfo(cnpj);
        },
        load_sectors() {
            return this.svc
                .load_sectors()
                .then((response) => response.data)
                .then((data) => {
                    this.sectors = data;
                    this.sectors.forEach((element) => {
                        element.text = element.name;
                    });
                    this.client.sectors = this.sectors
                        .map((s) => {
                            return this.client.sectors.filter((ss) => ss.id == s.id);
                        })
                        .flat();
                });
        },
        load_categories() {
            return this.cat_svc
                .list()
                .then((response) => response.data)
                .then((data) => {
                    this.categories = data;
                    this.categories.forEach((element) => {
                        element.text = element.name;
                        element.isCheck = true;
                    });
                    this.client.categories = data;
                });
        },
        setSelectedSystem(value) {
            this.$set(this.client, "id_sistema", value ? value.id : null);
        },
    },
    mounted() {
        this.load_sectors();
        if (!this.client.id) {
            this.load_categories();
        }
    },
};
</script>
